// This might seem silly or redundant but more conventional approaches like
//    this.outerFrame = row['outerFrame']?.toString() as string | null;
//    will either pass in no value or pass 0 as a number instead of as string.
// This enforces a null or string value.

export function stringOrNull(item: any) {
  if (item == null) {
    return null;
  } else {
    return item.toString();
  }
}